import { IconArrowRight } from '@/components/icons/IconArrowRight';
import type { NavItemDto } from '@/lib/sanity/dto';
import { cn } from '@/lib/utils/tw-merge';
import { BaseLink } from './BaseLink';

type SectionLinkProps = {
    item?: NavItemDto | null;
    className?: string;
};

/**
 * The quiet way out of a section — label, arrow, and a rule that grows under
 * both on hover. Its own component because three sections offer one and the
 * arrow is part of the pattern, not decoration a caller should have to
 * remember.
 */
export function SectionLink({ item, className }: SectionLinkProps) {
    if (!item?.label) return null;

    return (
        <BaseLink item={item} className={cn('section-link', className)}>
            {item.label}
            <IconArrowRight />
        </BaseLink>
    );
}
